import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claims`;

export interface SetClaimIssueCommandArgs {
  claimId: string;
  issueId: string;
}

export const setClaimIssueRequest = ({
  claimId,
  issueId,
}: SetClaimIssueCommandArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimId}/issue`,
  config: {
    method: SUPPORTED_METHODS.PUT,
    json: { issueId },
  },
});

export const setClaimIssueCommand = async (
  args: SetClaimIssueCommandArgs,
): Promise<BackResponse<Record<string, unknown>> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Record<string, unknown>>>(
      setClaimIssueRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
